
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/public",
      function () {
        return require("private-next-pages/cases/public/index.tsx");
      }
    ]);
  